import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Platform } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DswLanguageSwitcherComponent,
  DswMediumButtonDirective,
  DswMediumIconButtonDirective,
  DswPrimaryButtonComponent,
  DswSecondaryButtonComponent,
  DswSuffixDirective,
} from '@vi-succ/design-system-web';
import { LocaleService } from '../../core/locale/services/locale.service';
import { ProtectedTranslateService } from '../../core/locale/services/protected-translate.service';

@Component({
  selector: 'et-language-dialog',
  imports: [
    CommonModule,
    DswMediumIconButtonDirective,
    DswSuffixDirective,
    MatButton,
    MatDialogContent,
    MatDialogTitle,
    MatIconButton,
    TranslatePipe,
    DswLanguageSwitcherComponent,
    MatIconModule,
    MatDialogClose,
    DswMediumButtonDirective,
    DswPrimaryButtonComponent,
    DswSecondaryButtonComponent,
  ],
  templateUrl: './language-dialog.component.html',
  styleUrl: './language-dialog.component.scss',
})
export class LanguageDialogComponent {
  selectedLanguage!: string;
  isDesktop = this.platform.is('desktop');
  appLocales$ = this.localeService.appLocales$;

  constructor(
    private platform: Platform,
    private localeService: LocaleService,
    public translate: ProtectedTranslateService,
  ) {}
}
